<div class="jump-text-parent">
  <textarea appTextareaAutosize appTextareaJumptext [jumpTextTarget]="template()?.jumpTarget" [rows]="rows()" [style.background-color]="backgroundColor()" #templateEditor class="form-control jump-text-container" (paste)="pasteHandler($event)" (keyup)="keyupHandler($event)" [(ngModel)]="localValue"></textarea>
</div>
